// API Configuration - Environment-aware URL handling
const getApiUrl = () => {
  // In development, use localhost:5000
  console.log("import.meta.env.DEV :: ", import.meta.env);
  if (import.meta.env.NODE_ENV === 'development') {
    return `${process.env.REACT_APP_API_URL}/api` || 'http://localhost:5000/api';
  }

  // In production, use relative path (same domain)
  return '/api';
};

export const API_BASE_URL = getApiUrl();

// Helper function to build full API URLs
export const buildApiUrl = (endpoint) => {
  console.log("API_BASE_URL :: ", API_BASE_URL)
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

  // Remove trailing slash from base URL if present
  const cleanBaseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;

  return `${cleanBaseUrl}/${cleanEndpoint}`;
};
